import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/themes";
// @ts-ignore
import store from '@/stores';
import { computed } from "vue";

// Check if the user is authenticated from the store
const isAuthenticated = computed(() => store.state.auth.isAuthenticated);
const is2FAVerified = localStorage.getItem("2fa") === "true";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            name: "login",
            component: () => import("@/pages/Login.vue"),
            meta: { requiresAuth: false, requires2FA: false }
        },
        {
            path: "/auth-otp",
            name: "/auth-otp",
            component: () => import("../pages/TwoFactorAuthentication.vue"),
            meta: { requiresAuth: true, requires2FA: false }
        },
        {
            path: "/",
            component: Layout,
            children: [

                {
                    path: "home",
                    name: "home",
                    component: () => import("../pages/home/DashboardOverview.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },

                {
                    path: "app-version",
                    name: "app-version",
                    component: () => import("../pages/settings/Version.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "add-product",
                    name: "add-product",
                    component: () => import("../pages/AddProduct.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-classes",
                    name: "train-classes",
                    component: () => import("../pages/management/modules/TrainClasses.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-lines",
                    name: "train-lines",
                    component: () => import("../pages/management/modules/TrainLines.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-routes",
                    name: "train-routes",
                    component: () => import("../pages/management/modules/TrainRoutes.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "trains",
                    name: "trains",
                    component: () => import("../pages/management/modules/Trains.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "stations",
                    name: "stations",
                    component: () => import("../pages/management/modules/Stations.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-prices",
                    name: "train-prices",
                    component: () => import("../pages/management/modules/TrainPrices.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-prices/import-normal-price",
                    name: "import-normal-price",
                    component: () => import("../pages/management/form/ImportNormalPricePage.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-penaltys",
                    name: "train-penaltys",
                    component: () => import("../pages/management/modules/TrainPenalts.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "station-schedules",
                    name: "station-schedules",
                    component: () => import("../pages/management/modules/StationSchedules.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "zones",
                    name: "zones",
                    component: () => import("../pages/management/modules/Zones.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cards",
                    name: "cards",
                    component: () => import("../pages/card/Index.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "card-statement",
                    name: "card-statement",
                    component: () => import("../pages/card/CardStatement.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "account-card-statement/:card_number/:account_number",
                    name: "account-card-statement",
                    component: () => import("../pages/card/AccountCardStatement.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "account-balance-adjustment",
                    name: "account-balance-adjustment",
                    component: () => import("../pages/card/AccountAdjustment.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "balance-adjustment-approval",
                    name: "balance-adjustment-approval",
                    component: () => import("../pages/card/Adjustment/BalanceAdjustmentApproval.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/balance-adjustment-approval-detail/:token",
                    name: "balance-adjustment-approval-detail",
                    component: () => import("@/pages/card/Adjustment/BalanceAdjustmentApprovalProcessDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "customers",
                    name: "customers",
                    component: () => import("../pages/customer/modules/Customers.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "customer-accounts",
                    name: "customer-accounts",
                    component: () => import("../pages/customer/modules/CustomerAccounts.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "contract-institutions",
                    name: "contract-institutions",
                    component: () => import("../pages/customer/modules/ContractInstitutions.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "account-packages",
                    name: "account-packages",
                    component: () => import("../pages/customer/modules/AccountPackages.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "employee-incentive",
                    name: "employee-incentive",
                    component: () => import("../pages/customer/modules/EmployeeIncentive.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/employee-incentive-detail/:id",
                    name: "employee-incentive-detail",
                    component: () => import("@/pages/customer/modules/EmployeeIncentiveDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "devices",
                    name: "devices",
                    component: () => import("../pages/device/Index.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "suspicious_transaction",
                    name: "suspicious_transaction",
                    component: () => import("@/pages/validation/suspcious.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train_capacity",
                    name: "train_capacity",
                    component: () => import("@/pages/validation/trainCapacity.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "validation_transaction",
                    name: "validation_transaction",
                    component: () => import("@/pages/validation/index.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "collections",
                    name: "collections",
                    component: () => import("../pages/collections/Collections.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "collection-approval",
                    name: "collection-approval",
                    component: () => import("../pages/collections/CollectionApproval.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "operator-accounts",
                    name: "operator-accounts",
                    component: () => import("../pages/collections/OperatorAccounts.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "operator-accounts-details/:token",
                    name: "operator-accounts-details",
                    component: () => import("../pages/collections/OperatorAccountDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/collection-approval-detail/:token",
                    name: "collection-approval-detail",
                    component: () => import("@/pages/collections/ApprovalProcessDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/collections/detail/:token",
                    name: "collections-detail",
                    component: () => import("@/pages/collections/OperatorCollectionDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "operator-collection-items",
                    name: "operator-collection-items",
                    component: () => import("../pages/collections/OperatorCollectionItems.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "m10-summary",
                    name: "m10-summary",
                    component: () => import("../pages/collections/M10Summary.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo",
                    name: "cargo",
                    component: () => import("../pages/Luggage.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "reports",
                    name: "reports",
                    component: () => import("../pages/Report.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "manage-roles",
                    name: "manage-roles",
                    component: () => import("../pages/user/ManageRole.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "create-permission/:token",
                    name: "create-permission",
                    component: () => import("../pages/user/CreatePermission.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "system-users",
                    name: "system-users",
                    component: () => import("../pages/user/Users.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/system-user-details/:token",
                    name: "system-user-details",
                    component: () => import("@/pages/user/UserDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "coaches",
                    name: "coaches",
                    component: () => import("../pages/wagon/Wagons.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/coach-manufactures",
                    name: "coach-manufactures",
                    component: () => import("@/pages/wagon/Manufacture.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/coach-layouts",
                    name: "coach-layouts",
                    component: () => import("@/pages/wagon/WagonLayout.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/wagon-manufacture-detail/:token",
                    name: "wagon-manufacture-detail",
                    component: () => import("@/pages/wagon/ManufactureDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/wagon-layout-detail/:token",
                    name: "wagon-layout-detail",
                    component: () => import("@/pages/wagon/WagonLayoutDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/train-schedules",
                    name: "train-schedules",
                    component: () => import("@/pages/train/TrainSchedule.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/today-trains",
                    name: "today-trains",
                    component: () => import("@/pages/train/TodayTrains.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/transactions",
                    name: "transactions",
                    component: () => import("@/pages/transactions/index.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/adjustment-transactions",
                    name: "adjustment-transactions",
                    component: () => import("@/pages/transactions/AdjustmentTransactions.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cancel-transaction-approval",
                    name: "cancel-transaction-approval",
                    component: () => import("../pages/transactions/CancelTransactionApproval.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/cancel-transaction-approval-detail/:token",
                    name: "cancel-transaction-approval-detail",
                    component: () => import("@/pages/transactions/CancelTransactionApprovalProcessDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/transaction-detail/:id",
                    name: "transaction-detail",
                    component: () => import("@/pages/transactions/TransactionDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/ticket-topup-layout-detail/:id",
                    name: "ticket-topup-layout-detail",
                    component: () => import("@/pages/transactions/TransactionTopUpDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-card-detail/:id",
                    name: "show-card-detail",
                    component: () => import("@/pages/card/CardsDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-card-detail/:id",
                    name: "edit-card-detail",
                    component: () => import("@/pages/card/EditCardsDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-customer-detail/:id",
                    name: "show-customer-detail",
                    component: () => import("@/pages/customer/CustomerDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-customer-detail/:id",
                    name: "edit-customer-detail",
                    component: () => import("@/pages/customer/EditCustomerDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/replace-card-customer/:id",
                    name: "replace-card-customer",
                    component: () => import("@/pages/customer/ReplaceCard.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-operator-detail/:token",
                    name: "edit-operator-detail",
                    component: () => import("@/pages/device/EditOperatorDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-device-detail/:id",
                    name: "edit-device-detail",
                    component: () => import("@/pages/device/EditDeviceDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-train-detail/:id",
                    name: "edit-train-detail",
                    component: () => import("@/pages/management/EditTrainDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-customer-account-detail/:id",
                    name: "edit-customer-account-detail",
                    component: () => import("@/pages/customer/EditCustomerAccountDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-account-detail/:id",
                    name: "show-account-detail",
                    component: () => import("@/pages/customer/AccountDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-blocked-card-detail/:id",
                    name: "show-blocked-card-detail",
                    component: () => import("@/pages/customer/BlockedCardDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-contract-detail/:id",
                    name: "show-contract-detail",
                    component: () => import("@/pages/customer/ContractDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/train-detail/:id",
                    name: "show-train-detail",
                    component: () => import("@/pages/management/ViewDetails/TrainDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-package-detail/:id",
                    name: "show-package-detail",
                    component: () => import("@/pages/customer/PackageDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-operator-detail/:token",
                    name: "show-operator-detail",
                    component: () => import("@/pages/device/OperatorDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-operator-allocation-detail/:id",
                    name: "show-operator-allocation-detail",
                    component: () => import("@/pages/device/ShowOperatorAllocationDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/edit-operator-allocation-detail/:token",
                    name: "edit-operator-allocation-detail",
                    component: () => import("@/pages/device/EditOperatorAllocationDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-device-detail/:id",
                    name: "show-device-detail",
                    component: () => import("@/pages/device/DeviceDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/ticket-validation-detail/:id",
                    name: "ticket-validation-detail",
                    component: () => import("@/pages/validation/ValidationDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/ticket-suspicious-detail/:operator_id/:train_id/:category_id",
                    name: "ticket-suspicious-detail",
                    component: () => import("@/pages/validation/SuspiciousDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/train-capacity-detail/:id",
                    name: "train-capacity-detail",
                    component: () => import("@/pages/validation/CapacityDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/show-normal-price-detail/:id",
                    name: "show-normal-price-detail",
                    component: () => import("@/pages/management/NormalPriceDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                // {
                //     path: "special-group",
                //     name: "special-group",
                //     component: () => import("../pages/settings/SpecialGroup_backups.vue"),
                //     meta: { requiresAuth: true, requires2FA: true }
                // },
                {
                    path: "special-group",
                    name: "special-group",
                    component: () => import("../pages/settings/SpecialGroup.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "special-group/create",
                    name: "special-group-create",
                    component: () => import("../pages/settings/SpecialGroupForm.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "special-group/edit/:id",
                    name: "special-group-edit",
                    component: () => import("../pages/settings/SpecialGroupForm.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "incentive",
                    name: "incentive",
                    component: () => import("../pages/settings/IncentiveConfiguration.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "train-layouts",
                    name: "train-layouts",
                    component: () => import("../pages/train/TrainLayout.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "/train-layouts-details/:token",
                    name: "train-layouts-details",
                    component: () => import("@/pages/train/TrainLayoutDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "module-reports",
                    name: "module-reports",
                    component: () => import("../pages/reports/ModuleReports.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "device-summary-report",
                    name: "device-summary-report",
                    component: () => import("../pages/device/DeviceSummaryReport.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-customers",
                    name: "cargo-customers",
                    component: () => import("../pages/cargo/CargoCustomers.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-customer-details/:token",
                    name: "cargo-customer-details",
                    component: () => import("../pages/cargo/CargoCustomerDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-categories",
                    name: "cargo-categories",
                    component: () => import("../pages/cargo/CargoCategory.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-transactions",
                    name: "cargo-transactions",
                    component: () => import("../pages/cargo/CargoTransaction.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-transaction-detail/:token",
                    name: "cargo-transaction-detail",
                    component: () => import("../pages/cargo/CargoTransactionDetails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-configurations",
                    name: "cargo-configurations",
                    component: () => import("../pages/cargo/CargoCategory.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cargo-prices",
                    name: "cargo-prices",
                    component: () => import("../pages/cargo/CargoPrice.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "news-updates",
                    name: "news-updates",
                    component: () => import("../pages/news-updates/News.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "news-updates",
                    name: "news-updates",
                    component: () => import("../pages/news-updates/News.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "cfm-information",
                    name: "cfm-information",
                    component: () => import("../pages/news-updates/Information.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "audit-trails",
                    name: "audit-trails",
                    component: () => import("../pages/audit-trails/AuditTrails.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "audit-trail-detail/:token",
                    name: "audit-trail-detail",
                    component: () => import("../pages/audit-trails/AuditTrailDetail.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "profile",
                    name: "profile",
                    component: () => import("../pages/profile/Profile.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                {
                    path: "error-page",
                    name: "error-page",
                    component: () => import("../pages/ForbiddenPage.vue"),
                },
                {
                    path: "/new-registrations",
                    name: "new-registrations",
                    component: () => import("../pages/customer/NewRegistrations.vue"),
                    meta: { requiresAuth: true, requires2FA: true }
                },
                // {
                //     path: "phc-sync",
                //     name: "phc-sync",
                //     component: () => import("../pages/phc/PhcSync.vue"),
                //     meta: { requiresAuth: true, requires2FA: true }
                // }

            ]
        },

        {
            path: "/not-found",
            name: "not-found",
            component: () => import("../pages/NotFoundPage.vue"),
        },
        // {
        //   path: "/:catchAll(.*)", // Catch-all route for undefined paths
        //   redirect: "/not-found"
        // }
    ],
    scrollBehavior(_, _2, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { left: 0, top: 0 };
    }
});

// Navigation guard to handle authentication checks
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // If the route requires authentication and the user is not authenticated, redirect to login
    if (requiresAuth && !isAuthenticated.value) {
        next({ name: 'login' });
    }
    else if (to.meta.requires2FA && !is2FAVerified) {
        return next({ name: "/auth-otp" });
    }
    // If the user is authenticated and trying to access the login page, redirect to home
    else if (to.name === 'login' && isAuthenticated.value) {
        next({ name: 'home' });
    }
    // Otherwise, allow the navigation
    else {
        next();
    }
});

export default router;
